var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, flip, offset as floatingOffset, useDismiss, useFloating, useFocus, useHover, useInteractions, } from '@floating-ui/react';
import { cloneElement, useState } from 'react';
import { useId, useMergeRefs } from '../hooks';
import { Text } from '../text';
import { tokens } from '../tokens';
import { tooltipStyle } from './styles';
// Mapping between Waffles and floating-ui placement
const placementMap = {
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    right: 'right',
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
};
function Tooltip(_a) {
    var { children, content, inverted = false, offset = tokens.spacing.small, placement = 'bottom' } = _a, restProps = __rest(_a, ["children", "content", "inverted", "offset", "placement"]);
    const [isOpen, setIsOpen] = useState(false);
    const tooltipId = `tooltip-${useId()}`;
    const { context, refs, x, y } = useFloating({
        middleware: [floatingOffset(parseInt(offset, 10)), flip()],
        onOpenChange: setIsOpen,
        open: isOpen,
        placement: placementMap[placement],
        whileElementsMounted: autoUpdate,
    });
    const { getFloatingProps, getReferenceProps } = useInteractions([
        useHover(context, { delay: { close: 125, open: 750 } }),
        useFocus(context),
        useDismiss(context),
    ]);
    // @ts-expect-error: children.ref not recognized
    const triggerRef = useMergeRefs(refs.setReference, children.ref);
    const element = cloneElement(children, getReferenceProps(Object.assign(Object.assign({ key: children.key, ref: triggerRef }, children.props), (isOpen && { 'aria-describedby': tooltipId }))));
    return (_jsxs(_Fragment, { children: [element, isOpen && (_jsx(Text, Object.assign({}, getFloatingProps(Object.assign(Object.assign({}, restProps), { id: tooltipId, ref: refs.setFloating })), { as: "div", css: tooltipStyle({ inverted, x, y }), role: "tooltip" }, { children: content })))] }));
}
export default Tooltip;
